var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowRightSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 74,
    viewBox: "0 0 105 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.536 40.3554C105.488 38.4027 105.488 35.2369 103.536 33.2843L71.7157 1.46449C69.7631 -0.488136 66.5973 -0.488136 64.6447 1.46449C62.692 3.41711 62.692 6.58293 64.6447 8.53555L92.9289 36.8198L64.6447 65.1041C62.692 67.0567 62.692 70.2225 64.6447 72.1752C66.5973 74.1278 69.7631 74.1278 71.7157 72.1752L103.536 40.3554ZM0 36.8198V41.8198H100V36.8198V31.8198H0V36.8198Z",
    fill: "#2A4169"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightSmall);
export default __webpack_public_path__ + "static/media/icon-arrow-right-small.e4eafbcb539e24ccf9d8da684bb9a58a.svg";
export { ForwardRef as ReactComponent };